/**
 * apps/battle/client/src/Hud.tsx — Persistent XP/level/streak HUD.
 * Always visible per spec §7. Shows level badge, XP bar, streak, and student name.
 */
// Level curve: cumulative XP for level N = 100 * N*(N-1)/2 (matches LEVEL_CURVE in @econquest/shared)
function cumulativeXpForLevel(n: number): number {
  const lvl = Math.max(1, Math.floor(n));
  return (100 * (lvl * (lvl - 1))) / 2;
}

interface HudProps {
  name: string;
  level: number;
  totalXp: number;
  streakDays: number;
}

export function Hud({ name, level, totalXp, streakDays }: HudProps) {
  const currentLevelXp = cumulativeXpForLevel(level);
  const nextLevelXp = cumulativeXpForLevel(level + 1);
  const progress = nextLevelXp > currentLevelXp
    ? Math.min(100, Math.round(((totalXp - currentLevelXp) / (nextLevelXp - currentLevelXp)) * 100))
    : 100;

  return (
    <div className="hud">
      <span className="hud-level">Lv {level}</span>
      <div className="xp-bar-wrap">
        <div className="xp-bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <span className="hud-xp">{totalXp.toLocaleString()} XP</span>
      {streakDays > 0 && (
        <span className="hud-streak" title="Current streak">
          🔥 {streakDays}
        </span>
      )}
      <span className="hud-name">{name}</span>
    </div>
  );
}
